export default "__VITE_ASSET__Da5GZlU1__"